var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-popup-container",style:({ display: _vm.show ? 'flex' : 'none' })},[_c('envizion-loader',{attrs:{"size":48}}),_vm._m(0),_c('div',{staticClass:"loading-label"},[_vm._v(_vm._s(_vm.text || 'Preparing your workspace'))])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-progress-track"},[_c('div',{staticClass:"loading-progress-fill"})])
}]

export { render, staticRenderFns }